import { normalizeApiV1Base } from '../constants/apiEndpoints';
import { fetchWithTimeout } from '../utils/fetchWithTimeout';
import clientConfigService from './clientConfig';

const ADDRESS_PROXY_PATH = '/public/address';

function tenantApiBase() {
  const stored = localStorage.getItem('welliemd_client_api_endpoint');
  const base = stored || clientConfigService.config?.api_endpoint || '';
  return normalizeApiV1Base(base);
}

async function authHeaders(clientId) {
  const token = await clientConfigService.getEmbedToken(clientId);
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    Origin: window.location.origin,
  };
}

async function postAddress(clientId, segment, body, { signal } = {}) {
  const url = `${tenantApiBase()}${ADDRESS_PROXY_PATH}/${segment}/`;
  const response = await fetchWithTimeout(url, {
    method: 'POST',
    headers: await authHeaders(clientId),
    body: JSON.stringify(body),
    signal,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || data.detail || 'Address request failed');
    error.status = response.status;
    error.response = { status: response.status, data };
    error.code = data.code;
    throw error;
  }
  return data;
}

export function getAddressClientId() {
  // Embed tokens are minted for the control-plane client UUID (config.id), not the tenant DB row id.
  return clientConfigService.config?.id || localStorage.getItem('welliemd_client_id') || null;
}

export function isAddressProxyEnabled() {
  if (clientConfigService.config?.address_proxy_enabled) {
    return true;
  }
  return localStorage.getItem('welliemd_address_proxy_enabled') === '1';
}

export async function fetchAddressAutocomplete(clientId, q, { maxResults = 6, selected, signal } = {}) {
  const data = await postAddress(
    clientId,
    'autocomplete',
    { q, max_results: maxResults, selected },
    { signal },
  );
  return data.suggestions || [];
}

export async function verifyAddressViaProxy(clientId, candidateAddress = {}) {
  const { street, apt = '', city, state, zip } = candidateAddress;
  return postAddress(clientId, 'verify', {
    street: String(street || '').trim(),
    apt: String(apt || '').trim(),
    city: String(city || '').trim(),
    state: String(state || '').trim(),
    zip: String(zip || '').trim(),
  });
}

export async function resolveZipViaProxy(clientId, zipCode) {
  return postAddress(clientId, 'zip', { zip: String(zipCode || '').trim() });
}
